<div class="flex-row">
    <div class="flex-item">
        <div class="font-color-grey">{{ 'D38' | translate : locale : placeholders }}</div>
        <div class="percent">
            <span>{{ 'D39' | translate: locale }}</span>
        </div>
    </div>
    <div class="flex-item border-left-grey" *ngFor="let item of data">
        <div class="no-wrap value">{{ item.value | formattedNumber : locale }}</div>
        <div class="percent" [style.background-color]="item.backgroundColor">
            <span>{{ item.percent }}%</span>
        </div>

    </div>
</div>
<div class="baseline-container border-left-grey">
    <span class="baseline font-color-grey">{{ 'D13' | translate : locale }}</span>
</div>